
const LicenseRejectReasons =
{
    Duplicate: { Id: -1, Msg: 'It appears you\'ve already registered with us. Please log into pro.heroprogram.com or give us a call at 844-722-7559 with any questions.' },
    NotUnique: { Id: 3, Msg: 'It appears you\'ve already registered with us. Please log into pro.heroprogram.com or give us a call at 844-722-7559 with any questions.' },
    LicenseNotValid: { Id: 5, Msg: 'Issue with license. Please contact license authority to resolve.' },
    ExpirationNotFuture: { Id: 7, Msg: 'Expiration date must be in the future.' },
    InvalidFileType: { Id: 8, Msg: 'The file type selected is not supported. Please try again.' },
    Required: { Id: 9, Msg: 'Please provide all required fields before continuing.' },

};

export default LicenseRejectReasons;



// WEBPACK FOOTER //
// ./src/app/config/constants/LicenseRejectReasons.constant.js